const toDropdownValue = (value) => (Array.isArray(value) ? value : [value]);

export default toDropdownValue;
